import React from 'react';

const SignUpLink = () => (
  <p>
    {/* eslint-disable-next-line */}
    Don't have an account? {'  '}
    <a href="/signup">Sign Up</a>
  </p>
);


export default SignUpLink;



// WEBPACK FOOTER //
// ./src/components/UserManagement/SignUpLink.js